"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobxStateTree = require("mobx-state-tree");

var _patientPortalApiRequests = require("patient-portal-api-requests");

var _mobxDevtoolsMst = _interopRequireDefault(require("mobx-devtools-mst"));

var _dateFns = require("date-fns");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AccountInfo = _mobxStateTree.types.model("AccountInfo", {
  accountId: _mobxStateTree.types.identifierNumber,
  last: _mobxStateTree.types.string,
  first: _mobxStateTree.types.string,
  accountProvider: _mobxStateTree.types.integer
}).views(function (self) {
  return {
    get displayName() {
      return "".concat(self.last, " (").concat(self.accountId, ")");
    }

  };
});

var WalletInfo = _mobxStateTree.types.model("WalletInfo", {
  walletId: _mobxStateTree.types.identifierNumber,
  accountName: "",
  expiration: "",
  nickname: "",
  addressLine1: "",
  zip: "",
  cardTypeDesc: "",
  cardType: "",
  token: "",
  defaultMethod: false
}).views(function (self) {
  return {
    get displayName() {
      var maskedCard = "****" + self.token.slice(self.token.length - 4);
      var name = "";

      if (self.nickname) {
        name = self.nickname;
      } else {
        name = self.cardTypeDesc;
      }

      if (name.length > 0) {
        return name + " - " + maskedCard;
      } else {
        return maskedCard;
      }
    }

  };
});

var CardInfo = _mobxStateTree.types.model("CardInfo", {
  accountName: "",
  nickname: "",
  token: "",
  cvv: "",
  expiration: "",
  cardType: "",
  addressLine1: "",
  zip: "",
  shouldSave: false,
  saveAsDefault: false,
  addressRequired: true,
  zipRequired: true
}).views(function (self) {
  return {
    get displayName() {
      var maskedCard = self.token.slice(self.token.length - 4);
      var name = "";

      if (self.nickname) {
        name = self.nickname;
      } else {
        name = self.cardTypeDesc;
      }

      if (name.length > 0) {
        return name + " - " + maskedCard;
      } else {
        return maskedCard;
      }
    },

    get cardTypeDesc() {
      switch (self.cardType) {
        case "V":
          return "Visa";

        case "M":
          return "MasterCard";

        case "X":
          return "Amex";

        case "R":
          return "Discover";

        case "J":
          return "JCB";

        default:
          return "Other";
      }
    }

  };
}).actions(function (self) {
  return {
    clearCardInfo: function clearCardInfo() {
      self.token = "";
      self.cvv = "";
      self.expiration = "";
      self.cardType = "";
      self.nickname = "";
      self.shouldSave = false;
      self.saveAsDefault = false;
    },
    clearAccountInfo: function clearAccountInfo() {
      self.accountName = "";
      self.addressLine1 = "";
      self.zip = "";
    },
    shouldSaveChecked: function shouldSaveChecked() {
      var newVal = !self.shouldSave;
      self.shouldSave = newVal;
    },
    saveAsDefaultChecked: function saveAsDefaultChecked() {
      var newVal = !self.saveAsDefault;
      self.saveAsDefault = newVal;
    },
    setAccountName: function setAccountName(value) {
      self.accountName = value;
    },
    setNickname: function setNickname(value) {
      console.log("setnick: " + value);
      self.nickname = value;
    },
    setAddress: function setAddress(value) {
      self.addressLine1 = value;
    },
    setZip: function setZip(value) {
      self.zip = value;
    },
    setTokenResults: function setTokenResults(token, cvv, expiration, cardType) {
      self.token = token;
      self.cvv = cvv;
      self.expiration = expiration;
      self.cardType = cardType;
    }
  };
});

var ReceiptInfo = _mobxStateTree.types.model("ReceiptInfo", {
  officeName: _mobxStateTree.types.string,
  officeAddress: _mobxStateTree.types.maybe(_mobxStateTree.types.string),
  authorizedAmount: _mobxStateTree.types.number,
  cardTypeDesc: _mobxStateTree.types.string,
  transactionLogId: _mobxStateTree.types.number,
  authCode: _mobxStateTree.types.string,
  transactionDate: _mobxStateTree.types.Date,
  walletMessage: _mobxStateTree.types.maybe(_mobxStateTree.types.string)
}).actions(function (self) {
  return {
    clearMessage: function clearMessage() {
      self.walletMessage = undefined;
    }
  };
}).views(function (self) {
  return {
    get dateString() {
      return self.transactionDate.toLocaleDateString() + " " + self.transactionDate.toLocaleTimeString();
    }

  };
});

var MainFormStore = _mobxStateTree.types.model({
  portalUserId: _mobxStateTree.types.maybe(_mobxStateTree.types.number),
  manifest: _mobxStateTree.types.maybe(_mobxStateTree.types.string),
  tsepNeedsLoaded: true,
  //Payment Method Page
  selectedWallet: _mobxStateTree.types.safeReference(WalletInfo),
  wallets: _mobxStateTree.types.array(WalletInfo),
  enteredCardInfo: _mobxStateTree.types.optional(CardInfo, function () {
    return CardInfo.create();
  }),
  //Account Select Page
  selectedAccount: _mobxStateTree.types.safeReference(AccountInfo),
  accounts: _mobxStateTree.types.array(AccountInfo),
  paymentAmount: "",
  onlinePaymentTerms: "",
  onlinePaymentTermsLastUpdated: _mobxStateTree.types.maybe(_mobxStateTree.types.Date),
  userAcceptedTermsDate: _mobxStateTree.types.maybe(_mobxStateTree.types.Date),
  //Payment Results
  receiptInfo: _mobxStateTree.types.maybe(ReceiptInfo),
  error: ""
}).volatile(function () {
  return {
    loadingAccounts: true,
    loadingWallets: true
  };
}).actions(function (self) {
  return {
    setPortalUserId: function setPortalUserId(portalUserId) {
      self.portalUserId = portalUserId;
    },
    loadWallets: (0, _mobxStateTree.flow)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accountId) {
      var response, walletArray, defaultWalletIndex;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self.loadingWallets = true;
              _context.next = 3;
              return (0, _patientPortalApiRequests.getWallets)(accountId);

            case 3:
              response = _context.sent;
              walletArray = response;
              defaultWalletIndex = walletArray.findIndex(function (wallet) {
                return wallet.defaultMethod;
              }); //If there's a default wallet, put it first in the list
              //Splice removes the default wallet from the array and returns that object
              //Then unshift puts it back in the array at the beginning

              if (defaultWalletIndex > 0) {
                walletArray.unshift(walletArray.splice(defaultWalletIndex, 1)[0]);
              } //If any wallets were returned, select the first wallet


              if (walletArray.length > 0) {
                self.selectedWallet = walletArray[0].walletId;
              }

              self.wallets = walletArray;
              self.enteredCardInfo = undefined;
              self.loadingWallets = false;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })),
    selectWallet: function selectWallet(walletId) {
      self.selectedWallet = walletId;
    },
    loadAccounts: (0, _mobxStateTree.flow)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var response, accountId;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(self.portalUserId === undefined)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              self.loadingAccounts = true;
              _context2.next = 5;
              return (0, _patientPortalApiRequests.getAccounts)(self.portalUserId);

            case 5:
              response = _context2.sent;
              self.accounts = response;

              if (!(self.accounts.length > 0)) {
                _context2.next = 11;
                break;
              }

              accountId = self.accounts[0].accountId;
              _context2.next = 11;
              return self.selectAccount(accountId);

            case 11:
              _context2.next = 13;
              return self.loadPaymentTerms();

            case 13:
              self.loadingAccounts = false;

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })),
    loadPaymentTerms: (0, _mobxStateTree.flow)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var response;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!self.onlinePaymentTerms) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              _context3.prev = 2;
              _context3.next = 5;
              return (0, _patientPortalApiRequests.getPaymentTermsOfService)();

            case 5:
              response = _context3.sent;
              self.onlinePaymentTerms = response.termsHTML;
              self.onlinePaymentTermsLastUpdated = (0, _dateFns.parseISO)(response.lastUpdated);
              _context3.next = 12;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](2);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 10]]);
    })),
    loadManifest: (0, _mobxStateTree.flow)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(accountProvider) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _patientPortalApiRequests.getManifest)(accountProvider);

            case 2:
              self.manifest = _context4.sent;

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })),
    selectAccount: (0, _mobxStateTree.flow)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(accountId) {
      var accountChanged;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              //If selecting account for first time (selectedAccount undefined)
              //or changing selected account, load wallets again
              accountChanged = !self.selectedAccount || self.selectedAccount.accountId !== accountId;
              self.selectedAccount = accountId;

              if (!accountChanged) {
                _context5.next = 6;
                break;
              }

              self.loadWallets(accountId);
              _context5.next = 6;
              return self.loadManifest(self.selectedAccount.accountProvider);

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })),
    setPaymentAmount: function setPaymentAmount(amount) {
      self.paymentAmount = amount;
    },
    setReceiptInfo: function setReceiptInfo(data) {
      var model = ReceiptInfo.create(_objectSpread(_objectSpread({}, data), {}, {
        transactionDate: (0, _dateFns.parseISO)(data.transactionDate)
      }));
      self.receiptInfo = model;
    },
    setError: function setError(errorMessage) {
      self.error = errorMessage;
    },
    setTSEPInfo: function setTSEPInfo(data) {
      var model = CardInfo.create(data);
      self.enteredCardInfo = model;
    },
    markUserTermsAgreement: function markUserTermsAgreement(checked) {
      if (checked) {
        (0, _patientPortalApiRequests.acceptPaymentTermsOfService)(self.portalUserId);
        self.userAcceptedTermsDate = new Date();
      } else {
        self.userAcceptedTermsDate = undefined;
      }
    },
    tsepScriptsLoaded: function tsepScriptsLoaded() {
      self.tsepNeedsLoaded = false;
    },
    reloadTSEPScripts: function reloadTSEPScripts() {
      self.tsepNeedsLoaded = true;
      self.enteredCardInfo.clearCardInfo();
    }
  };
}).actions(function (self) {
  return {
    reload: function reload() {
      if (typeof self.enteredCardInfo !== "undefined") {
        self.loadWallets(self.selectedAccount.accountId);
        self.enteredCardInfo = undefined;
      }

      self.paymentAmount = "";
      self.receiptInfo = undefined;
      self.error = "";
      self.userAcceptedTermsDate = undefined;
      self.tsepNeedsLoaded = true;
    }
  };
}).views(function (self) {
  return {
    get selectedPaymentMethod() {
      //If we have a token for a manually entered card, use that
      if (self.enteredCardInfo.token) {
        return self.enteredCardInfo; //Otherwise use the selected wallet
      } else if (self.selectedWallet) {
        return self.selectedWallet;
      }

      return {};
    },

    get userAcceptedTerms() {
      return self.userAcceptedTermsDate !== undefined;
    },

    get postPaymentData() {
      var _self$selectedPayment, _self$selectedPayment2;

      return {
        accountId: self.selectedAccount.accountId,
        accountProviderId: self.selectedAccount.accountProvider,
        requestedAmount: Number(self.paymentAmount),
        walletId: self.selectedPaymentMethod.walletId,
        token: self.selectedPaymentMethod.token,
        expiration: self.selectedPaymentMethod.expiration,
        cvv: self.selectedPaymentMethod.cvv,
        accountName: self.selectedPaymentMethod.accountName,
        nickname: self.selectedPaymentMethod.nickname,
        address: self.selectedPaymentMethod.addressLine1,
        zip: self.selectedPaymentMethod.zip,
        cardType: self.selectedPaymentMethod.cardType,
        patientPortalUserId: self.portalUserId,
        saveCardOnFile: (_self$selectedPayment = self.selectedPaymentMethod.shouldSave) !== null && _self$selectedPayment !== void 0 ? _self$selectedPayment : false,
        saveAsDefault: (_self$selectedPayment2 = self.selectedPaymentMethod.saveAsDefault) !== null && _self$selectedPayment2 !== void 0 ? _self$selectedPayment2 : false
      };
    }

  };
});

var mainStore = MainFormStore.create();

if (process.env.NODE_ENV === "development") {
  (0, _mobxDevtoolsMst.default)(mainStore);
}

var _default = mainStore;
exports.default = _default;